import * as Yup from "yup";

export const loginSchema = Yup.object({
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .required("Password is required"),
});

export const registrationSchema = Yup.object({
  firstName: Yup.string()
    .required("First name is required"),
  lastName: Yup.string()
    .required("Last name is required"),
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .required("Password is required"),
});

export const forgotPasswordSchema = Yup.object({
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
});

export const inviteMemberSchema = Yup.object({
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
});

export const invitationRegisterSchema = Yup.object({
  firstName: Yup.string().required("First name is required"),
  lastName: Yup.string().required("Last name is required"),
  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .required("Password is required"),
});

export const resetPasswordSchema = Yup.object({
  newPassword: Yup.string().min(6, "At least 6 characters").required(
    "Enter new password",
  ),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("newPassword")], "Passwords must match")
    .required("Confirm your new password"),
});

export const updatePasswordSchema = Yup.object({
  oldPassword: Yup.string().required("Enter old password"),
  newPassword: Yup.string().min(6, "At least 6 characters").required(
    "Enter new password",
  ),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("newPassword")], "Passwords must match")
    .required("Confirm your new password"),
});

export const profileSchema = Yup.object({
  firstName: Yup.string().when("$isSupermode", {
    is: false,
    then: (schema) => schema.required("First name is required"),
    otherwise: (schema) => schema.optional(),
  }),
  lastName: Yup.string().when("$isSupermode", {
    is: false,
    then: (schema) => schema.required("Last name is required"),
    otherwise: (schema) => schema.optional(),
  }),
});

export const addBrandSchema = Yup.object({
  brand: Yup.string()
    .trim()
    .required("Brand is required")
    .test(
      "not-only-spaces",
      "Brand cannot contain only spaces and special characters",
      (value) => {
        if (!value) return false;
        const meaningfulContent = value.replace(/[\s\W_]/g, "");
        return meaningfulContent.length > 0;
      },
    ),
});
export const superuserSchema = Yup.object({
  email: Yup.string().email("Invalid email address").required(
    "Email is required",
  ),
});
